import { apiFetch } from "../api";

const PREFIX = process.env.REACT_APP_URL_NEWS_ROOT + "Territory/";

export const getTerritories = () => {
  return apiFetch(`${PREFIX}`);
};
